module.exports = __webpack_public_path__ + "static/img/mobile_iapp.9046987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/mobile_iapp.jpg
// module id = 506
// module chunks = 0